import { IEmailTemplateEnquiry } from './enquiry';

export interface IEmailTemplateEnquiryUpdate {
  [key: string]: IEmailTemplateEnquiry;
}
